import { render, staticRenderFns } from "./motto-icon.vue?vue&type=template&id=dcfe22a0"
import script from "./motto-icon.vue?vue&type=script&lang=js"
export * from "./motto-icon.vue?vue&type=script&lang=js"
import style0 from "./motto-icon.vue?vue&type=style&index=0&id=dcfe22a0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports